import React from 'react'

export const IconEmptyNotifications = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="281" height="122" viewBox="0 0 281 122" fill="none" {...props}>
    <g filter="url(#filter0_d_7985_225438)">
      <rect x="46.9917" y="54.0687" width="186.963" height="38.5711" rx="5.98281" fill="white" />
      <rect
        x="47.3656"
        y="54.4427"
        width="186.215"
        height="37.8233"
        rx="5.60888"
        stroke="#E9EEF1"
        strokeWidth="0.747851"
      />
    </g>
    <path
      d="M214.29 68.1288C214.874 66.9126 216.606 66.9126 217.19 68.1288L218.115 70.0546C218.121 70.0656 218.131 70.0734 218.144 70.0751L220.262 70.3602C221.599 70.5401 222.134 72.1876 221.158 73.119L219.611 74.5936C219.603 74.6021 219.598 74.6148 219.601 74.6268L219.984 76.7294C220.227 78.0565 218.826 79.0744 217.639 78.4344L215.758 77.4198C215.747 77.414 215.733 77.414 215.723 77.4198L213.842 78.4344C212.654 79.0747 211.253 78.0566 211.495 76.7294L211.879 74.6268C211.881 74.6148 211.877 74.6021 211.868 74.5936L210.322 73.119C209.346 72.1875 209.882 70.5401 211.219 70.3602L213.337 70.0751C213.349 70.0733 213.359 70.0655 213.364 70.0546L214.29 68.1288Z"
      fill="#E9EEF1"
      stroke="#E9EEF1"
      strokeWidth="1.57225"
    />
    <circle
      cx="67.3485"
      cy="73.354"
      r="10.876"
      fill="#E9EEF1"
      stroke="#E9EEF1"
      strokeWidth="0.747851"
    />
    <rect
      x="85.4003"
      y="62.4781"
      width="30.3233"
      height="5.68067"
      rx="2.61748"
      fill="#E9EEF1"
      stroke="#E9EEF1"
      strokeWidth="0.747851"
    />
    <rect
      x="85.4003"
      y="73.7282"
      width="98.3585"
      height="3.53783"
      rx="1.76891"
      fill="#F2F5F7"
      stroke="#E9EEF1"
      strokeWidth="0.747851"
    />
    <rect
      x="85.4003"
      y="80.6922"
      width="75.8587"
      height="3.53783"
      rx="1.76891"
      fill="#F2F5F7"
      stroke="#E9EEF1"
      strokeWidth="0.747851"
    />
    <g filter="url(#filter1_d_7985_225438)">
      <rect x="34.8076" y="37.3932" width="211.33" height="43.5982" rx="5.98281" fill="white" />
      <rect
        x="35.1815"
        y="37.7671"
        width="210.582"
        height="42.8503"
        rx="5.60888"
        stroke="#E9EEF1"
        strokeWidth="0.747851"
      />
    </g>
    <path
      d="M224.809 53.4691C225.107 52.8473 225.993 52.8473 226.292 53.4691L227.459 55.8998C227.579 56.1494 227.817 56.322 228.091 56.3589L230.764 56.7183C231.447 56.8103 231.721 57.6525 231.222 58.1288L229.271 59.9905C229.071 60.1817 228.98 60.4608 229.03 60.7333L229.514 63.3861C229.638 64.0648 228.921 64.5853 228.314 64.2578L225.941 62.9777C225.697 62.8462 225.403 62.8462 225.16 62.9777L222.786 64.2578C222.179 64.5853 221.463 64.0648 221.586 63.3861L222.07 60.7333C222.12 60.4608 222.029 60.1817 221.829 59.9905L219.878 58.1288C219.379 57.6525 219.653 56.8103 220.336 56.7183L223.009 56.3589C223.283 56.322 223.521 56.1494 223.641 55.8998L224.809 53.4691Z"
      fill="#E9EEF1"
    />
    <circle cx="57.8182" cy="59.1922" r="12.7161" fill="#E9EEF1" />
    <rect x="77.8003" y="46.4761" width="35.1208" height="7.26636" rx="2.9914" fill="#E9EEF1" />
    <rect x="77.8003" y="59.1927" width="112.023" height="4.84424" rx="2.42212" fill="#F2F5F7" />
    <rect x="77.8003" y="67.0632" width="86.5908" height="4.84424" rx="2.42212" fill="#F2F5F7" />
    <g filter="url(#filter2_d_7985_225438)">
      <rect x="23.9312" y="19.4441" width="233.083" height="48.086" rx="5.98281" fill="white" />
      <rect
        x="24.3051"
        y="19.818"
        width="232.336"
        height="47.3381"
        rx="5.60888"
        stroke="#E9EEF1"
        strokeWidth="0.747851"
      />
    </g>
    <circle cx="49.3097" cy="43.4867" r="14.0251" fill="#E9EEF1" />
    <rect x="71.3496" y="29.4617" width="38.7359" height="8.01433" rx="2.9914" fill="#E9EEF1" />
    <rect x="71.3496" y="43.4879" width="123.554" height="5.34289" rx="2.67144" fill="#F2F5F7" />
    <rect x="71.3496" y="52.168" width="95.5041" height="5.34289" rx="2.67144" fill="#F2F5F7" />
    <defs>
      <filter
        id="filter0_d_7985_225438"
        x="23.0605"
        y="34.6246"
        width="234.825"
        height="86.4336"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4.48711" />
        <feGaussianBlur stdDeviation="11.9656" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.6625 0 0 0 0 0.6625 0 0 0 0 0.6625 0 0 0 0.2 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_7985_225438" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_7985_225438"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_7985_225438"
        x="10.8764"
        y="17.9491"
        width="259.193"
        height="91.4606"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4.48711" />
        <feGaussianBlur stdDeviation="11.9656" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.6625 0 0 0 0 0.6625 0 0 0 0 0.6625 0 0 0 0.2 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_7985_225438" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_7985_225438"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_d_7985_225438"
        x="-7.82013e-05"
        y="-3.29018e-05"
        width="280.946"
        height="95.9484"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4.48711" />
        <feGaussianBlur stdDeviation="11.9656" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.6625 0 0 0 0 0.6625 0 0 0 0 0.6625 0 0 0 0.2 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_7985_225438" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_7985_225438"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)
